import { useState } from 'react';
import { connect } from 'react-redux';
import {
  fetchCancellationReasons,
  refundOrder,
} from 'actions/orderCancellation';
import { resetOrder } from 'actions/orderSearch';

let _content = null;

const OrderAcceptComplete = (props) => {
  const { resetOrder, order, currentStaff } = props;

  const [redirect, setRedirect] = useState(false);
  const [orderNumber, setOrderNumber] = useState(null);
  const [successModal, setSuccessModal] = useState(true);

  const cleanStateAndRedirect = () => {
    resetOrder();
    setRedirect(true);
  };

  const closeModal = () => {
    setSuccessModal(false);
    setRedirect(true);
    setOrderNumber(order.number);
    resetOrder();
  };

  const printPage = () => {
    window.print();
  };

  return (
    _content &&
    _content({
      props,
      redirect,
      orderNumber,
      successModal,
      currentStaff,
      cleanStateAndRedirect,
      closeModal,
      printPage,
    })
  );
};

const mapDispatchToProps = {
  fetchCancellationReasons,
  refundOrder,
  resetOrder,
};

const mapStateToProps = (state) => ({
  order: state.orderCancellation.order,
  orderItems: state.orderCancellation.orderItems,
  refundInvoiceNumber: state.orderCancellation.refundInvoiceNumber,
  error: state.orderCancellation.error,
  pending: state.orderCancellation.pending,
  cancellationReasons: state.orderCancellation.cancellationReasons,
  currentStaff: state.staffs.currentStaff,
  success: state.orderCancellation.success,
});

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(OrderAcceptComplete);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/orders/cancellation/orderRefundComplete/index.js